<template>
  <div>
    <page-header title="صفحه درباره ما" english-toggle></page-header>

    <v-card class="settings-card">
      <v-card-title><v-icon left>mdi-information</v-icon>محتوای فارسی</v-card-title>
      <v-card-text>
        <TextEditor v-model="fa_value" direction="rtl"></TextEditor>
      </v-card-text>
    </v-card>

    <v-card v-if="$store.state.showEnglishFields" class="settings-card">
      <v-card-title><v-icon left>mdi-translate</v-icon>محتوای انگلیسی</v-card-title>
      <v-card-subtitle>اختیاری - در صورت خالی بودن، محتوای فارسی ذخیره می‌شود.</v-card-subtitle>
      <v-card-text>
        <v-text-field v-model="en_value" dir="ltr" color="#00ADB5" outlined label="English"></v-text-field>
<!--        <TextEditor v-model="en_value" direction="ltr"></TextEditor>-->
      </v-card-text>
    </v-card>

    <div class="form-actions">
      <v-btn class="btn-primary" large depressed @click="updateContent">
        <v-icon left>mdi-content-save</v-icon>
        ذخیره تغییرات
      </v-btn>
    </div>
  </div>
</template>

<script>
import TextEditor from "@/components/General/TextEditor.vue";
import PageHeader from "@/components/General/PageHeader.vue";

export default {
    name: "ContactUs",
  components: {TextEditor, PageHeader},

    data() {
        return {
            en_value: null,
            fa_value: null,
        }
    },

    mounted() {
        this.getContent()
    },

    methods: {
        getContent() {
            this.$store.dispatch("getAboutUsContent").then((res) => {
                this.en_value = res.data.en_value
                this.fa_value = res.data.fa_value
            })
        },

        updateContent() {
            this.$store.dispatch("updateAboutUs", {
                en_value: this.en_value,
                fa_value: this.fa_value
            })
        },

        onNamespaceLoaded( CKEDITOR ) {
            CKEDITOR.plugins.addExternal( 'image2', '/plugins/image2/plugin.js');
            CKEDITOR.plugins.addExternal( 'justify', '/plugins/justify/plugin.js');
        }
    }
}
</script>

<style scoped>

</style>